export type MenuGamepadAction = 'previous' | 'next' | 'activate' | 'back';

/** UI gamepad edges; ignores buttons already held when a dialog opens. */
export class MenuGamepadInput {
  readonly #held = new Set<MenuGamepadAction>();
  #initialized = false;

  reset(): void { this.#held.clear(); this.#initialized = false; }

  poll(): MenuGamepadAction | null {
    const pad = Array.from(navigator.getGamepads?.() ?? []).find((item): item is Gamepad => Boolean(item?.connected));
    if (!pad) { this.reset(); return null; }
    const current = new Set<MenuGamepadAction>();
    const vertical = pad.axes[1] ?? 0;
    if (pad.buttons[12]?.pressed || vertical < -0.65) current.add('previous');
    if (pad.buttons[13]?.pressed || vertical > 0.65) current.add('next');
    if (pad.buttons[0]?.pressed) current.add('activate');
    if (pad.buttons[1]?.pressed) current.add('back');
    if (!this.#initialized) {
      this.#initialized = true;
      for (const action of current) this.#held.add(action);
      return null;
    }
    let edge: MenuGamepadAction | null = null;
    for (const action of ['back', 'previous', 'next', 'activate'] as const) {
      if (current.has(action) && !this.#held.has(action) && edge === null) edge = action;
    }
    this.#held.clear();
    for (const action of current) this.#held.add(action);
    return edge;
  }
}
